export class ScheduleStats {
    district: string;
    month: number;
    locked: number;
    mandatory: number;
    available: number;
    planned: number;
    total: number;
}
